import { isNumber } from 'intact-shared';
export var ROOT_LAYOUT = 'RootLayout';
export var LAYOUT = 'Layout';
export var BODY = 'LayoutBody';
export var defaultHeight = "64px";
export var defaultWidth = "200px";
export function getStyle(height) {
  return isNumber(height) ? height + "px" : height;
}